import React, { FunctionComponent } from 'react';
import { UserProfile } from 'fitbeat.gym-core';
import { StyleSheet, Text, View } from 'react-native';
import FastImage from 'react-native-fast-image';
import { getConfig } from '../../config';
import { getImage, mealRowPressed } from '../../Nutrition/actions';
import { openPaywallModalAction } from '../../payments/redux/payments-actions';
import Theme from '../../theme';
import { LinearGradient, toggleMealModal } from '../../ui';
import { HorizontalScrollerCard } from './HorizontalScrollerCard';
import { connect } from 'react-redux';
import { PaywallPage } from '../../auth';

interface IProps {
  t: (key: string) => string;
  nutritionData: any;
  navigation: any;
  lastCard?: boolean;
  mealRowPressed: (mealOfDay, currentMeal) => void;
  getImage: (nutritionService, mealId: string) => void;
  toggleMealModal: (visible: boolean) => void;
  openPaywallModalAction: (paywallPage) => void;
  user: any;
  userProfile: UserProfile;
}

const MealCardComponent: FunctionComponent<IProps> = ({
                                                        t,
                                                        nutritionData,
                                                        lastCard = false,
                                                        navigation,
                                                        mealRowPressed,
                                                        getImage,
                                                        toggleMealModal,
                                                        openPaywallModalAction,
                                                        user,
                                                        userProfile
                                                      }) => {


  const openMealModal = () => {
    if (!UserProfile.hasActivePlan(userProfile)) {
      openPaywallModalAction(PaywallPage.Nutrition);
      return;
    }
    mealRowPressed(nutritionData.timeOfMeal, nutritionData);
    getImage(user.nutritionService, nutritionData._id);
    toggleMealModal(true);
  };

  return (
    <HorizontalScrollerCard style={styles.container}
                            onPress={openMealModal}
                            wideCard={!nutritionData}
                            lastCard={lastCard}
    >
      {
        !nutritionData &&
        <>
          <FastImage
            style={styles.backgroundImage}
            source={{ uri: getConfig().nutritionPlaceHolderImage }}
            resizeMode={'cover'}
          />
          <Text style={styles.label}>{t('setUpMealPrefError')}</Text>
        </>
      }
      {
        nutritionData &&
        <>
          <FastImage
            style={styles.backgroundImage}
            source={{ uri: nutritionData[getConfig().nutritionDashTileImageType] }}
            resizeMode={'cover'}
          />
          <Text style={styles.label}>{t(nutritionData.timeOfMeal)}: {nutritionData.displayName}</Text>
        </>
      }
      <LinearGradient
        colors={['transparent', Theme.BLACK]}
        style={[styles.gradient]}
        webClassName={'summary-dashboard-slider-image-tile'}
      />
    </HorizontalScrollerCard>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'flex-end',
  },
  backgroundImage: {
    height: '100%',
    width: '100%',
    position: 'absolute',
    zIndex: 0,
  },
  label: {
    ...Theme.textStyle.bodyCopyBold,
    color: Theme.WHITE,
    margin: 15,
    textTransform: 'uppercase',
    zIndex: 2,
  },
  gradient: {
    ...StyleSheet.absoluteFill,
    opacity: 0.4,
  },
});

export const MealCard = connect(null, {
  toggleMealModal,
  getImage,
  mealRowPressed,
  openPaywallModalAction,
})(MealCardComponent)
